<template>
  <div id="personalDetails">
    <ValidationObserver ref="observer" @submit.prevent="close()" slim>
      <div class="form" :class="[$mq, {TA:isTestAchat}]">
        <h1>{{ $t("Contract.PersonalDetails.title") }}</h1>
        <BecomeField
          name="civility"
          type="switch"
          v-if="!haveCivility"
          v-model="civility"
          :possibleValues="civilities"
          required
        ></BecomeField>
        <BecomeField
          name="birthdate"
          :label="$t('Contract.PersonalDetails.birthdate')"
          type="calendar"
          v-if="!haveBirthdate"
          v-model="birthDate"
          :defaultDate="defaultDate"
          :calendarRules="birthDateRule"
          :required="customerType === 'resi'"
        ></BecomeField>
        <BecomeField
          name="phone"
          type="phone"
          v-if="!havePhone"
          :label="$t('Contract.PersonalDetails.phone.label')"
          :help="$t('Contract.PersonalDetails.phone.help')"
          :rules="phoneRule"
          v-model="phone"
          placeholder="498000000"
          required
        ></BecomeField>
        <BecomeField
          name="email"
          type="email"
          v-if="!haveMail"
          :label="$t('Contract.PersonalDetails.mail.label')"
          :help="$t('Contract.PersonalDetails.mail.help')"
          rules="email"
          v-model="mail"
          required
        ></BecomeField>
        <div v-if="customerType === 'pro'">
          <BecomeField
            name="vat_number"
            type="text"
            :label="$t('Situation.PersonalDetails.vatNumber.label')"
            :help="$t('Situation.PersonalDetails.vatNumber.help')"
            :value="vatNumber"
            @input="getEnterprise($event)"
            required
          ></BecomeField>
          <BecomeField
            name="companyName"
            type="text"
            :label="$t('Situation.PersonalDetails.companyName')"
            v-model="companyName"
            required
          ></BecomeField>
          <BecomeField
            name="legalForm"
            type="select"
            :label="$t('Situation.PersonalDetails.legalForm')"
            v-model="legalForm"
            :possibleValues="legalForms"
            required
          ></BecomeField>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import BecomeField from "@/components/Form/BecomeField";
import enterpriseService from "@/services/enterpriseService";
import { mapState, mapGetters } from 'vuex';
import dateRules from '@/validations/dateRules';

export default {
  data() {
    return {
      haveMail: false,
      havePhone: false,
      haveCivility: false,
      haveBirthdate: false,
    };
  },
  computed: {
    ...mapState("subscription", ["customerType"]),
    ...mapGetters("subscription", ["isTestAchat"]),
    civilities() {
      return [
        {
          label: this.$t("Situation.PersonalDetails.civilities.MA"),
          value: "MA",
        },
        {
          label: this.$t("Situation.PersonalDetails.civilities.MO"),
          value: "MO",
        },
      ];
    },
    civility: {
      get() {
        return this.$store.state.subscription.civility;
      },
      set(value) {
        this.$store.commit("subscription/setCivility", value);
      },
    },
    birthDate: {
      get() {
        return this.$store.state.subscription.birthDate;
      },
      set(value) {
        this.$store.commit("subscription/setBirthDate", value);
      },
    },
    defaultDate() {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 50);

      return date;
    },
    phone: {
      get() {
        return this.$store.state.subscription.phone;
      },
      set(value) {
        this.$store.commit("subscription/setPhone", value);
      },
    },
    phoneRule() {
      return this.phone.prefix === "+32" ? "be-phone" : "phone";
    },
    mail: {
      get() {
        return this.$store.state.subscription.mail;
      },
      set(value) {
        this.$store.commit("subscription/setMail", value);
      },
    },
    vatNumber: {
      get() {
        return this.$store.state.subscription.vatNumber;
      },
      set(value) {
        this.$store.commit("subscription/setVatNumber", value);
      },
    },
    companyName: {
      get() {
        return this.$store.state.subscription.companyName;
      },
      set(value) {
        this.$store.commit("subscription/setCompanyName", value);
      },
    },
    legalForm: {
      get() {
        return this.$store.state.subscription.legalForm;
      },
      set(value) {
        this.$store.commit("subscription/setLegalForm", value);
      },
    },
    legalForms() {
      let result = [];
      let legalForms = this.$store.state.common.legalForms;

      legalForms.forEach((legalForm) => {
        let line = {
          label: legalForm[this.$i18n.locale],
          value: legalForm.code,
        };

        result.push(line);
      });

      return result;
    },
  },
  methods: {
    birthDateRule(date) {
      return !dateRules.birthDate(date);
    },
    async getEnterprise(value) {
      this.vatNumber = value;

      if (value.length > 6) {
        try {
          let response = await enterpriseService.get(value);
          this.companyName = response.name.fr || response.name.nl;
          this.legalForm = response.legal_form;
        } catch (error) {
          if (error.response.status === 400) {
            this.$refs.observer.setErrors({
              vat_number: this.$t("Validation.vat_number"),
            });
          }
        }
      }
    },
  },
  created() {
    this.haveMail = this.mail !== null;
    this.havePhone = this.phone !== null && this.phone.number.length;
    this.haveBirthdate = this.birthDate !== null;
    this.haveCivility = this.civility !== null;

    if(!this.legalForms.length) this.$store.dispatch("common/getLegalForms");
  },
  components: {
    BecomeField,
  },
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;

  .close {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background: $clearYellow;
    font-size: 0.8rem;
  }
}

.flex {
  flex: 1 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/MissingDetails.vue